import { useCallback } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import {
  BILLING_VALID_TABS,
  type BillingTab,
  UnifiedBillingView,
  type BillingSubSearch,
  validateBillingSubSearch,
} from "@/components/billing/unified-billing-view";

interface BillingSearch extends BillingSubSearch {
  tab: BillingTab;
}

/**
 * Provider workspace billing alias. Per legacy `UnifiedBillingContent`
 * rationale, all 5 workspace billing URLs render the SAME user-level
 * payer surface IN PLACE — no redirect, so the user keeps their
 * workspace context (provider sidebar/nav).
 */
export const Route = createFileRoute("/_authenticated/account/provider/billing")({
  validateSearch: (search: Record<string, unknown>): BillingSearch => {
    const raw = typeof search.tab === "string" ? search.tab : "";
    return {
      tab: BILLING_VALID_TABS.includes(raw as BillingTab) ? (raw as BillingTab) : "subscription",
      ...validateBillingSubSearch(search),
    };
  },
  component: ProviderBillingPage,
});

function ProviderBillingPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate();
  const setTab = useCallback(
    (next: BillingTab) => navigate({ to: "/account/provider/billing", search: { tab: next } }),
    [navigate],
  );
  return (
    <>
      <UnifiedBillingView
        activeTab={tab}
        onTabChange={setTab}
        workspace={{ entityType: "provider" }}
      />
      <AccountSecurityBanner />
    </>
  );
}
